import api from '@/js/services/api';
export default {

    getTodoInfo(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }
        return api().get('/master-admin/dashboard/to-do/get?'+ searchParams.toString())
    },

    getApplicantsInfo() {
        return api().get('/master-admin/dashboard/applicants/get')
    },

    getShiftsInfo(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }
        return api().get('/master-admin/dashboard/shifts/get?'+ searchParams.toString())
    },

    getStandByInfo(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get('/master-admin/dashboard/stand-by/get?' + searchParams.toString())
    },
}
